module.exports = __webpack_public_path__ + "img/user.e23787fc.jpg";